// Account usage over a date range (/api/admin/usage).

import { apiFetch } from './api';

export interface SiteUsage {
  siteId: string;
  name: string;
  conversations: number;
  messages: { visitor: number; agent: number; ai: number };
  aiReplies: number;
  aiAssists: number;
  inputTokens: number;
  outputTokens: number;
  aiCostUsd: number | null;
  humanRequests: number;
  newsletterSignups: number;
  ticketsCreated: number;
  knowledgeEntries: number;
  openSuggestions: number;
}

export interface UsageReport {
  range: { from: string; to: string };
  totals: Omit<SiteUsage, 'siteId' | 'name'>;
  sites: SiteUsage[];
  daily: Array<{ day: string; conversations: number; aiReplies: number }>;
}

export function getUsage(from: Date, to: Date): Promise<UsageReport> {
  return apiFetch<UsageReport>(`/api/admin/usage?from=${from.toISOString()}&to=${to.toISOString()}`);
}
